import { AppPage } from '@launchpad';
import React from 'react';
import { AuthorisationImportFileTable } from '../../components/AuthorisationImportFileTable';

const AuthorisationFilesList = (props) => {
  return (
    <AppPage title="Uploaded files" icon="list">
      <AuthorisationImportFileTable />
    </AppPage>
  );
};

export default AuthorisationFilesList;
